/* * Version: 1.0.0
 * Letzte Änderung: 16.09.2026, 12:45
 * Änderungshistorie: Erstellung der Login-Maske für den Administrator-Zugang des Turnier-Managers.
 * Copyright: BAIT-Tech
 */
import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const LoginScreen = () => {
  // Lokale States für die Eingabefelder
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  // Zugriff auf unseren globalen Auth-Context
  const { login, error, loading, userInfo } = useContext(AuthContext);
  
  // React Router Hook für die Seiten-Navigation
  const navigate = useNavigate();

  // Wenn der Benutzer bereits eingeloggt ist (userInfo existiert), 
  // leiten wir ihn sofort weiter, damit er die Login-Seite gar nicht erst sieht.
  useEffect(() => {
    if (userInfo) {
      navigate('/'); // Nach erfolgreichem Login z.B. zur Turnierübersicht leiten
    }
  }, [navigate, userInfo]);

  // Handler für das Absenden des Formulars
  const submitHandler = async (e) => {
    e.preventDefault(); // Verhindert das Standard-Neuladen der Seite durch den Browser
    
    // Führt die Login-Funktion aus dem Context aus
    const success = await login(email, password);
    if (success) {
      navigate('/'); // Erfolgreich eingeloggt -> ab in den Admin-Bereich
    }
  };

  // =============================================================================
  //  RENDER LOGIK
  // =============================================================================
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f4f9' }}>
      <div style={{ background: '#fff', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px', color: '#333' }}>BAIT-Tech Turnier-Admin</h2>
        
        {/* Fehlermeldung anzeigen, falls der Login fehlschlägt */}
        {error && (
          <div style={{ color: '#d9534f', marginBottom: '15px', textAlign: 'center', padding: '10px', background: '#f2dede', borderRadius: '4px', border: '1px solid #ebccd1' }}>
            {error}
          </div>
        )}
        
        <form onSubmit={submitHandler}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#555', fontWeight: 'bold' }}>E-Mail Adresse</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            />
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: '#555', fontWeight: 'bold' }}>Passwort</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ccc', boxSizing: 'border-box' }}
            />
          </div>
          
          <button 
            type="submit" 
            disabled={loading}
            style={{ 
              width: '100%', 
              padding: '12px', 
              backgroundColor: '#007bff', 
              color: '#fff', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: loading ? 'not-allowed' : 'pointer', 
              fontSize: '16px',
              fontWeight: 'bold',
              transition: 'background-color 0.3s'
            }}
          >
            {loading ? 'Wird geprüft...' : 'Einloggen'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;